import { UpdateRegistrationSteps } from '@/connection/registration/registration-steps';
import { RootState } from '@/store/main';
import { serializeError } from '@/store/utils/serialize-error';
import { GetDefaultRegistrationSteps } from '@/utils/registration/registration';
import { updateRegistrationSteps } from '..';
import { ProjectStateReducerCreator } from '../types';

const setRegistrationOnReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (isOn: boolean, { rejectWithValue, getState, dispatch }) => {
      try {
        const state = getState() as RootState;
        if (state.project.workingProject && !state.project.workingProject.registration_steps?.length) {
          const defaultSteps = GetDefaultRegistrationSteps();

          dispatch(updateRegistrationSteps({ steps: defaultSteps }));
          await UpdateRegistrationSteps(state.project.workingProject.uuid, defaultSteps);
        }

        return isOn;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (state.workingProject) {
          state.workingProject.registration_on = action.payload;
        }
      },
    }
  );
};

export default setRegistrationOnReducer;
